// extracted by mini-css-extract-plugin
export default {"horizontal":"Divider_horizontal__JMCFo"};